import { PersonalDataForm } from 'components/contexts/accreditation';

export const PersonalData = () => <PersonalDataForm />;
